<template>
    <div v-if="widgetReady">
        <div class="row form-group">
            <div class="col-lg-12">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" :id="identifier" v-model="manualAddress" :disabled="viewOnly" />
                    <label class="form-check-label" :for="identifier">&nbsp;I will manually enter my Address</label>
                </div>
            </div>
        </div>

        <div class="row" v-show="!manualAddress">
            <div class="col-lg-9">
                <div class="form-group">
                    <label>
                        Address/Location
                        <span v-if="showRequiredLabel"><small><span class="redText">required </span></small></span>
                    </label>
                    <input ref="autocompleteRef" placeholder="Enter your address" type="text" class="form-control" autocomplete="off" :disabled="viewOnly" />
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                    <label>Apt/Suite</label>
                    <input type="text" class="form-control " placeholder="Apt/Suite" v-model="model.address2" :disabled="viewOnly" />
                </div>
            </div>
        </div>

        <div class="row" v-if="manualAddress">
            <div class="col-lg-9">
                <div class="form-group">
                    <label>
                        Street Address
                        <span v-if="showRequiredLabel"><small><span class="redText">required </span></small></span>
                    </label>
                    <input type="text" class="form-control" placeholder="Street Address" v-model="model.address1">
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                    <label>Apt/Suite</label>
                    <input type="text" class="form-control " placeholder="Apt/Suite" v-model="model.address2">
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label>
                        City
                        <span v-if="showRequiredLabel"><small><span class="redText">required </span></small></span>
                    </label>
                    <input type="text" class="form-control" placeholder="City" v-model="model.city">
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                    <label>
                        State
                        <span v-if="showRequiredLabel"><small><span class="redText">required </span></small></span>
                    </label>
                    <select class="form-control" v-model="model.stateProvinceId">
                        <option v-for="state in states" v-bind:value="state.stateProvinceId">
                            {{ state.name }} - {{ state.stateProvinceCode }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="form-group">
                    <label>
                        Zip
                        <span v-if="showRequiredLabel"><small><span class="redText">required </span></small></span>
                    </label>
                    <input type="text" class="form-control" placeholder="Zip Code" v-model="model.zipCode">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLoader from 'google-maps';
    import _ from 'lodash';
    import {configTables} from "../../global/configTables.js";
    import {formatter} from "../../global/formatter.js";

    export default {
        name: "AcAddress",
        props: {
            value: {type: Object, required: true},
            identifier: {type: String, required: false, default: 'address'},
            viewOnly: {type: Boolean, required: false, default: false},
            showRequiredLabel: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                widgetReady: false,
                manualAddress: false,
                autocomplete: null,
                states: [],
                model: {...this.value}
            }
        },
        watch: {
            model: {
                deep: true,
                handler(value) {
                    this.$emit('input', value);
                    //console.log("Model property has been updated, value:", value);
                }
            }
        },
        async mounted() {
            let self = this;
            //let GoogleMapsLoader = await import('google-maps');
            //console.log('GoogleMapsLoader', GoogleMapsLoader);
            this.states = await configTables.getStates();//We need states ready when setting the address in the autocomplete
            GoogleMapsLoader.KEY = 'AIzaSyBULgN2oWltDQFqUfdnoAFSg76UcLTbvvM';
            GoogleMapsLoader.LIBRARIES = ['places'];
            GoogleMapsLoader.VERSION = '';
            GoogleMapsLoader.load(function (google) {
                self.widgetReady = true;
                self.$nextTick(function () {
                    //console.log('self.$refs:', self.$refs, 'autocomplete:', self.$refs.autocompleteRef);
                    self.autocomplete = new google.maps.places.Autocomplete(
                        self.$refs.autocompleteRef,
                        {types: ['geocode']}
                    );
                    self.autocomplete.addListener('place_changed', self.autocompleteCallback);
                    $(self.$refs.autocompleteRef).keyup(function() { 
                        if (self.$refs.autocompleteRef.value) return; 
                        // console.log("mounted autocompleteRef place:", self.$refs.autocompleteRef.value);
                        self.model = {}; 
                    });
                    //Check if the address has already been set
                    //console.log("autocomplete:", self.autocomplete);
                    this.setOriginalAddress(this.model);
                });
            });
        },
        methods: {
            setOriginalAddress(address) {
                //console.log("Original address:", address);
                // if (!Boolean(address.addressId)) { ---->we can get the address from stripe so there is no id
                //     return;
                // }
                if (!Boolean(address.address1) || !Boolean(address.city) ||
                    !Boolean(address.zipCode)) {
                    return;
                }
                let stateCode = null;
                if (address.stateProvinceId) {
                    stateCode = this.findStateCode(address.stateProvinceId)
                }
                let formattedAddress = formatter.formatAddress(address.address1, address.address2, address.city, stateCode, address.zipCode);
                //console.log("Formatted address: ", formattedAddress, "autocomplete:", $(this.$refs.autocompleteRef));
                $(this.$refs.autocompleteRef).val(formattedAddress);
            },
            autocompleteCallback() {
                let place = this.autocomplete.getPlace();
                //console.log('place inside autocomplet callback:', place);
                let findFunc = (type) => {
                    return _.find(place.address_components, (c) => {
                        return c.types.indexOf(type) > -1;
                    });
                };
                let streetNumber = findFunc('street_number').long_name;
                let street = findFunc('route').long_name;
                let city = findFunc('locality').long_name;
                let state = findFunc('administrative_area_level_1').short_name;
                let zipcode = findFunc('postal_code').long_name;
                //console.log(streetNumber, street, city, state, zipcode);
                //Address 1 is special since google separates street number and street
                this.model.address1 = streetNumber + ' ' + street;
                this.model.address2 = "";
                this.model.city = city;
                this.model.stateProvinceId = this.findStateId(state);
                this.model.zipCode = zipcode;
                this.model.latitude = place.geometry.location.lat();
                this.model.longitude = place.geometry.location.lng();
                //console.log("Updated model: ", this.model);
            },
            findStateId(stateCode) {
                let match = _.find(this.states, (state) => {
                    return state.stateProvinceCode === stateCode;
                });
                //console.log('this.states: ', this.states, ' match: ', match);
                return match.stateProvinceId;
            },
            findStateCode(stateId) {
                let match = _.find(this.states, (state) => {
                    return state.stateProvinceId === stateId;
                });
                return match.stateProvinceCode;
            }
        }
    }
</script>

<style>
    .pac-container {
        z-index: 1051 !important;
    }

    .form-group {
        margin-bottom: 15px;
    }
</style>